// Module
var code = `<span class="deck-copy">{{copy}}</span>
`;
// Exports
module.exports = code;